import cx from "classnames";
import React, { useState } from "react";

import { ExpandableClamp } from "@/mk2/components/ExpandableClamp";
import { RenderAST } from "@/mk2/components/RenderAST";
import { ShowPhotosAndVideos } from "@/mk2/helpers/article_ast/filters";
import { getAllDescendantsOfTypes } from "@/mk2/helpers/article_ast/utils";
import { ContentItemEntity } from "@/mk2/schemas";
import { BLOGS_ALBUM_DESCRIPTION_SHOW_MORE } from "@/mk/autogenerated/translation";

import styles from "./StrollersSearchInfos.mscss";

interface OwnProps {
    className?: string;
    searchInfos: ContentItemEntity[];
}

type Props = OwnProps;

export const StrollersSearchInfos: React.FunctionComponent<Props> = React.memo(
    ({ className, searchInfos }) => {
        const [showMediaSeparately, setShowMediaSeparately] = useState<boolean>(true);
        const toggleShowMediaSeparately = () => {
            setShowMediaSeparately(!showMediaSeparately);
        };

        // NOTE: search infos currently support one item (the plan is to show more in such cases)
        const searchInfo = searchInfos?.[0];
        if (!searchInfo) {
            return null;
        }
        const mediaNodes = getAllDescendantsOfTypes(searchInfo.contentAST, [
            "pic",
            "youtube",
            "vimeo",
            "giphy",
        ]);
        const mediaNode = mediaNodes ? mediaNodes[0] : null;

        return (
            <div className={cx(styles.StrollersSearchInfos, className)}>
                <ExpandableClamp
                    expandLabel={BLOGS_ALBUM_DESCRIPTION_SHOW_MORE}
                    clamp={5}
                    onExpand={toggleShowMediaSeparately}
                >
                    <RenderAST
                        contentAST={searchInfos?.[0]?.contentAST}
                        linkedObjects={searchInfos?.[0]?.contentASTAdditionalData.linkedObjects}
                        showPhotosAndVideos={
                            showMediaSeparately ? ShowPhotosAndVideos.NONE : ShowPhotosAndVideos.ALL
                        }
                        renderSpecialWikiLinks={false}
                        customStyles={{
                            paragraph: styles.StrollersSearchInfos__paragraph,
                            youtube: styles.StrollersSearchInfos__youtube,
                        }}
                    />
                </ExpandableClamp>
                {showMediaSeparately && (
                    <RenderAST
                        contentAST={mediaNode}
                        linkedObjects={{}}
                        renderSpecialWikiLinks={false}
                        customStyles={{
                            paragraph: styles.StrollersSearchInfos__paragraph,
                            youtube: styles.StrollersSearchInfos__youtube,
                        }}
                    />
                )}
            </div>
        );
    },
);

StrollersSearchInfos.displayName = "StrollersSearchInfos";
